export class SalesrepModel {
    team_code: string;
    team_name: string;
    salesrep_code: string;
    salesrep_name: string;
}


// WEBPACK FOOTER //
// ./src/models/user/salesrep.model.ts